import React from "react";

export default function CompLeaveCollection(getMiniCompLeaveBalance, intl) {
    let miniCompLeaveBalance = []
    if(getMiniCompLeaveBalance.length > 0) {
        for (var i = 0; i < getMiniCompLeaveBalance.length; i++) {
            miniCompLeaveBalance.push({
                id: `${getMiniCompLeaveBalance[i].id}`,
                dataSubmitted: `${getMiniCompLeaveBalance[i].date_request}`,
                expiryDate: `${getMiniCompLeaveBalance[i].expire_date}`,
                description: `${getMiniCompLeaveBalance[i].description}`,
                earn: `${getMiniCompLeaveBalance[i].earn}`,
                used: `${getMiniCompLeaveBalance[i].used}`,
                cashOut: `${getMiniCompLeaveBalance[i].cash_out}`,
                remaining: `${getMiniCompLeaveBalance[i].remaining}`,
            });
        }
    }
    return miniCompLeaveBalance;
}
